import store from '@/store'
import commonFun from "@/utils/commonFun";

export default {
    acl: function(el, binding, vnode, oldVnode) {
        let functions = store.state.main.functions;
        // console.log(functions)
        let needs = commonFun.stringConvertToArray(binding.expression, ",");
        let havePermission = false;
        needs.forEach(value => {
            if (functions.indexOf(value) >= 0) {
                havePermission = true;
            }
        })
        if (!havePermission) {
            el.style.display = 'none';
        }
    },
    ic: function(el, binding, vnode, oldVnode) {
        let [table, field] = binding.value.split(":");
        let icList = commonFun.listIC(table, field);
        if (commonFun.isNotEmpty(icList)) {
            let vue = el.__vue__;
            vue.options = icList.sort((o1, o2) => o1.seq >= o2.seq).map(obj => {
                return { value: obj.code, label: obj.value };
            })
        }
    },

}